import React, { useCallback, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PageLoader from '../../ui-library/PageLoader';
import { useAuth } from './AuthProvider';

const LoginCallback: React.FC = () => {
  const { user, isInitializing, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const asyncInit = useCallback(() => {
    const error = searchParams.get('error');
    const errorDescription = searchParams.get('error_description') ?? '';

    if (error) {
      const params = new URLSearchParams({ error, error_description: errorDescription });
      navigate(`/login-error?${params.toString()}`, { replace: true });
      return;
    }

    if (!isInitializing) {
      if (isAuthenticated && user) {
        // 'Sign in complete' is tracked by AuthProvider's populateUserProfile
        // for every method (popup and redirect), so this route only navigates.
        navigate('/chat');
      } else {
        navigate('/');
      }
    }
  }, [searchParams, isInitializing, navigate, isAuthenticated, user]);

  useEffect(() => {
    asyncInit();
  }, [asyncInit]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <PageLoader />
    </div>
  );
};

export default LoginCallback;
